const SDK_VERSION = '7.73.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
